import { useEffect, useRef, useState } from 'react'

const pwaMediaQuery = 'not ((display-mode: browser) or (display-mode: fullscreen))'

export const pwaMediaQueryMatch = window.matchMedia(pwaMediaQuery)

export function useIsPwa(): boolean {
  const [isPwa, setIsPwa] = useState(pwaMediaQueryMatch.matches)

  useEffect(() => {
    const listener = (e: MediaQueryListEvent) => {
      if (e.matches !== isPwa) {
        setIsPwa(e.matches)
      }
    }
    // NOTE: In our CI Electron the following methods are undefined
    pwaMediaQueryMatch.addEventListener?.('change', listener)
    return () => {
      pwaMediaQueryMatch.removeEventListener?.('change', listener)
    }
  })

  return isPwa
}

export function useMediaQueryState(query: string) {
  const match = useRef<MediaQueryList | undefined>()
  if (match.current == null) {
    match.current = window.matchMedia(query)
  }
  const [matches, setMatches] = useState(match.current.matches)

  useEffect(() => {
    const listener = (e: MediaQueryListEvent) => {
      setMatches(e.matches)
    }
    // NOTE: In our CI Electron the following methods are undefined
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    match.current!.addEventListener?.('change', listener)
    return () => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      match.current!.removeEventListener?.('change', listener)
    }
  }, [query])

  return matches
}
